module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-view', {
    attrs: {
      "endpoint": _vm.endpoint + 'ssosettings',
      "name": "SSO Settings",
      "parentRoute": "images",
      "permissions": "ssosettings",
      "values": _vm.values,
      "noPathId": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9082f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrgSSOSettingsEdit.vue
// module id = 427
// module chunks = 1